import axios from "axios";

export default function marketingEmailSubscription() {
  return ({ url, list_id, email, message }) => {
    return axios({
      url: url,
      method: "POST",
      headers: {
        revision: "2022-04-18",
      },
      data: {
        data: {
          type: "subscription",
          attributes: {
            list_id: list_id,
            custom_source: message,
            email: email,
          },
        },
      },
    })
      .then(console.log("Email consent has been given"))
      .catch((error) => {
        if (axios.isCancel(error)) {
          console.log("Request canceled", error.message);
        } else {
          throw error;
        }
      });
  };
}
